import React from 'react';

import type {ColorName} from '../../colors/colors';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Source from './icon-audience-goal.svg';

type Props = {
    color?: ColorName;
};

function SvgComponent(props: Props) {
    const validProps = Object.assign({}, props);
    // @ts-expect-error
    delete validProps.styles;

    return <Source {...validProps} color={props.color || '#7A7370'} />;
}
SvgComponent.iconName = 'goalAudience';

/**
 * @deprecated This is a legacy icon
 */
export const GoalAudienceIcon = svgIconWrapper(SvgComponent);
